import type { UnknownAction } from 'redux';

import { reportStoreTypes, reportUpserters } from '../core';
import * as actions from './accountsValueChangesActions';
import type { AccountsValueChangesStore } from './accountsValueChangesTypes';

const initialState = reportStoreTypes.mkReportStore({}) as AccountsValueChangesStore;

const reducer = (state: AccountsValueChangesStore = initialState, action: UnknownAction): AccountsValueChangesStore => {
  switch (true) {
    case actions.getAccountsValueChanges.match(action):
      return state.set('isLoading', true);

    case actions.getAccountsValueChangesSuccess.match(action):
      return reportUpserters.upsertReports(state, action.payload);

    case actions.getAccountsValueChangesFailure.match(action):
      return state.merge({ error: action.payload, isLoading: false });

    default:
      return state;
  }
};

export default reducer;
